import { render, staticRenderFns } from "./AllHeader.vue?vue&type=template&id=3fedf3c1&scoped=true&"
import script from "./AllHeader.vue?vue&type=script&lang=js&"
export * from "./AllHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fedf3c1",
  null
  
)

export default component.exports